import { appInfo } from './AppInfo';
var skstockAppInfo = {
    isPhone: function () {
        return appInfo.loginType === 2;
    }
};
export default skstockAppInfo;
//# sourceMappingURL=skstockAppInfo.js.map